module.exports = __webpack_public_path__ + "static/media/BT.6b8573f1.png";